/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Deliverable_DescriptionInputs */



/**
* | output |
* | --- |
* | "Chosen here rather than described in the instructions, so the agent delivers the same thing on every run." |
*
* @param {Agent_Builder_Deliverable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_deliverable_description = /** @type {((inputs?: Agent_Builder_Deliverable_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Deliverable_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier ausgewählt statt in den Anweisungen beschrieben, damit der Agent bei jedem Lauf dasselbe liefert.")
	return /** @type {LocalizedString} */ ("Chosen here rather than described in the instructions, so the agent delivers the same thing on every run.")
});